<template>
  <div class="progress-percent-chart">
    <common-label title="対応中事故の進捗率割合">
      <template v-slot:contents>
        <common-chart
          :chartData="chartData"
          chartId="progress-percent-chart"
        ></common-chart>
      </template>
    </common-label>
  </div>
</template>

<script>
import { ColorMixin } from "@/mixins";
import CommonLabel from "./CommonLabel.vue"
import CommonChart from "./CommonChart.vue"

/*
 * 事故種類別の発生件数
 */

export default {
  name: "M.ProgressPercentChart",
  mixins: [ColorMixin],
  props: {
    chartData: {
      type: Array,
      required: true,
    },
  },
  components: {
    CommonLabel,
    CommonChart
  },
}
</script>

<style>
</style>